"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var style_1 = require("@lyearn/style");
function SvgCopyIcon(_props, svgRef) {
    var props = (0, style_1.useSvg)(_props);
    return (React.createElement("svg", tslib_1.__assign({ width: 24, height: 24, viewBox: "0 0 24 24", ref: svgRef }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9 13v-1c0-1.654 1.346-3 3-3h1V5.667A.667.667 0 0012.333 5H5.667A.667.667 0 005 5.667v6.666c0 .368.299.667.667.667H9zm0 2H5.667A2.67 2.67 0 013 12.333V5.667A2.67 2.67 0 015.667 3h6.666A2.67 2.67 0 0115 5.667V9h3c1.654 0 3 1.346 3 3v6c0 1.654-1.346 3-3 3h-6c-1.654 0-3-1.346-3-3v-3zm2-3c0-.551.449-1 1-1h6c.552 0 1 .449 1 1v6c0 .551-.448 1-1 1h-6c-.551 0-1-.449-1-1v-6z" })));
}
exports["default"] = React.forwardRef(SvgCopyIcon);
//# sourceMappingURL=CopyIcon.js.map